export const ROLE_USER = 'USER';
export const ROLE_ADMIN = 'ADMIN';
export const TEST_FRONTEND = 'TEST_FRONTEND';
export const TEST_FULLSTACK = 'TEST_FULLSTACK';
export const WH_PROPORTION = 1.5;
